import { connect } from 'react-redux';
import { getIsAnonymized } from 'edrolo/domains/anonymizer';
import ExamGridContainer from './ExamGridContainer';

const mapStateToProps = (state) => {
  return {
    isAnonymized: getIsAnonymized(state),
  };
};

export default connect(mapStateToProps)(ExamGridContainer);
